import { createFileRoute } from '@tanstack/react-router'
import IcpDetailPage from '@/components/business-value/IcpDetailPage'
import { smartManufacturing } from '@/data/business-value'

export const Route = createFileRoute('/_app/business-value/smart-manufacturing')({
  component: SmartManufacturingPage,
})

function SmartManufacturingPage() {
  return <IcpDetailPage icp={smartManufacturing} />
}
